"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrerequisiteToJSON = exports.PrerequisiteFromJSONTyped = exports.PrerequisiteFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function PrerequisiteFromJSON(json) {
    return PrerequisiteFromJSONTyped(json, false);
}
exports.PrerequisiteFromJSON = PrerequisiteFromJSON;
function PrerequisiteFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'prerequisiteType': (0, _1.PrerequisiteTypeFromJSON)(json['prerequisiteType']),
        'description': !(0, runtime_1.exists)(json, 'description') ? undefined : json['description'],
        'amount': !(0, runtime_1.exists)(json, 'amount') ? undefined : json['amount'],
        'nftGroupingId': !(0, runtime_1.exists)(json, 'nftGroupingId') ? undefined : json['nftGroupingId'],
        'questId': !(0, runtime_1.exists)(json, 'questId') ? undefined : json['questId'],
        'guildId': !(0, runtime_1.exists)(json, 'guildId') ? undefined : json['guildId'],
        'event': !(0, runtime_1.exists)(json, 'event') ? undefined : (0, _1.EventValidatorFromJSON)(json['event']),
        'challengeId': !(0, runtime_1.exists)(json, 'challengeId') ? undefined : json['challengeId'],
    };
}
exports.PrerequisiteFromJSONTyped = PrerequisiteFromJSONTyped;
function PrerequisiteToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'prerequisiteType': (0, _1.PrerequisiteTypeToJSON)(value.prerequisiteType),
        'description': value.description,
        'amount': value.amount,
        'nftGroupingId': value.nftGroupingId,
        'questId': value.questId,
        'guildId': value.guildId,
        'event': (0, _1.EventValidatorToJSON)(value.event),
        'challengeId': value.challengeId,
    };
}
exports.PrerequisiteToJSON = PrerequisiteToJSON;
